import { render } from "./SchedulePlanningPage.vue?vue&type=template&id=f38cb6d8"
import script from "./SchedulePlanningPage.vue?vue&type=script&lang=ts"
export * from "./SchedulePlanningPage.vue?vue&type=script&lang=ts"
script.render = render

export default script